angular.module('wbDashboard').controller('OverviewSummaryProgressControllerAurea',
    ['$scope', 'User', '$uibModal', 'PlanService', function ($scope, User, $uibModal, PlanService) {

        $scope.showProgressModal = function() {
            var modalInstance = $uibModal.open({
                templateUrl: 'overview.progress.modal.tpl.html',
                size: 'md',
                scope: $scope,
                windowClass: 'full-head-modal'
            });

            return modalInstance.result.catch(angular.noop);
        };

        $scope.$watch(User.getNewPerformance, function(performance) {
            if (performance) {
                $scope.performance = performance;

                let graphData = {
                    values: performance.values,
                    color: 'money'
                };
                $scope.progressGraph = {plotData: [graphData]};
            }
        });

        $scope.$watch(function() { return User.getMilestoneByType('retirement'); }, function(retirement) {
            if (retirement) {
                $scope.retirement = retirement;

                angular.forEach($scope.retirement.accounts, function(a) {
                    if (a.type.includes('ira')) {
                        a.is_ira = true;
                    }
                });
            }
        });

        $scope.graphHeight = function() {
            return Math.max(window.innerHeight - 500, 250);
        };

}]);
